module.exports = __webpack_public_path__ + "static/media/pause_blue.49f3d07f.svg";